import type { FaireProductEntity } from "../../entity_types/product";

export const p_1tz8mvu4ol: FaireProductEntity = {
  token: "p_1tz8mvu4ol",
  type: "product",
  name: "Hawaii\u00a0Note Card Stationery Set",
  brandName: "Amanda Klein Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/67a2b6f5048bc520eea4f6c70340f3d62150897af44b646ec4100974431289a9.jpeg",
  priceDollars: 10,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/c44cd0be654bcad14b9e2d565d5c7da8176ddb62551d472a6ad9fd487a1e58d4.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
